import React, { FC } from 'react';
import { IconProps } from './IconInterface';

export const ConnectedSitesIcon: FC<IconProps> = ({ fill, width, height }: IconProps) => (
  <svg id="Layer_1" viewBox="0 0 32 32" width={width} height={height} fill={fill}>
    <path
      d="M26.24,19.3a5.68,5.68,0,0,0-5.12,3.19L10.65,18.73a5.45,5.45,0,0,0,.8-2.73,5.45,5.45,0,0,0-.8-2.73L21.12,9.51a5.77,5.77,0,0,0,5.12,3.19A5.63,5.63,0,0,0,31.93,7,5.69,5.69,0,0,0,20.55,7v.34l-11.49,4a5.52,5.52,0,0,0-3.3-1.13,5.69,5.69,0,0,0,0,11.38,5.53,5.53,0,0,0,3.3-1.14l11.49,4.21V25a5.69,5.69,0,1,0,5.69-5.69Zm0-15.93a3.35,3.35,0,0,1,3.41,3.41,3.41,3.41,0,1,1-6.82,0A3.42,3.42,0,0,1,26.24,3.37ZM2.35,15.89a3.35,3.35,0,0,1,3.41-3.42,3.42,3.42,0,0,1,0,6.83A3.35,3.35,0,0,1,2.35,15.89ZM26.24,28.4A3.41,3.41,0,1,1,29.65,25,3.35,3.35,0,0,1,26.24,28.4Z"
      fill="current"
    />
  </svg>
);
